import { Popup } from "react-map-gl";
import { useTranslation } from "react-i18next";
import { formatDateValue } from "../util/tableUtils";

export const EmergencyPopupDetails = ({ overview }: { overview: TerraShieldOverview }) => {
  const { t } = useTranslation();

  return (
    <Popup longitude={overview.lng} latitude={overview.lat} closeButton={false}>
      <div>
        <b>{t("emergencyMonitoring.category")}</b>: {overview.category}
      </div>
      <div>
        <b>{t("emergencyMonitoring.name")}</b>: {overview.name}
      </div>
      <div>
        <b>{t("emergencyMonitoring.eventTime")}</b>: {formatDateValue(overview.eventTime)}
      </div>
    </Popup>
  );
};
